import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="appbar-brand"]' },
  { target: '[data-tour="profile-menu"]' },
  { target: '[data-tour="families-header"]' },
  { target: '[data-tour="families-grid"]' },
  { target: '[data-tour="family-card-rename"]' },
  { target: '[data-tour="create-family-card"]' },
  { target: '[data-tour="invite-hint"]' }
];

export const FAMILIES_LIST_TOUR_STEPS: TourStep[] = buildTourSteps('familiesList', STEP_DEFS);

export const FAMILIES_LIST_TOUR_STORAGE_KEY = 'wetree-families-tour-completed';
export const FAMILIES_LIST_WELCOME_STORAGE_KEY = 'wetree-families-welcome-dismissed';
